import type { IconSvgObject } from './types';

const VoicemailIcon: IconSvgObject = [
  ["circle", { cx: "6", cy: "12", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "18", cy: "12", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 16H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default VoicemailIcon;
